import Button from "components/base/button/button";
import { useAppStore } from "store";
import { observer } from "mobx-react";
import { DELAY_TIME_LONGER } from "constants/constants";
import { IQueryParams } from "models/dto/ZoomiLxp/Models/Query/IQueryParams";

interface ISearchClearButtonProps {
	setIsClear: (isClear: boolean) => void;
	getInitParams?: () => IQueryParams;
}

const SearchClearButton = (props: ISearchClearButtonProps) => {
	const { setIsClear, getInitParams } = props;
	const { searchStore } = useAppStore();
	const isClearFunction = () => {
		if (getInitParams) {
			searchStore.clearStoreAll(true);
			searchStore.params = getInitParams();
		} else {
			searchStore.clearStoreAll();
		}
		setIsClear(true);
		setTimeout(() => setIsClear(false), DELAY_TIME_LONGER);
	};
	return (
		<Button label="Clear" type="secondary" size="common" onClick={isClearFunction} labelColor="textLayoutHeader" />
	);
};
export default observer(SearchClearButton);
